import {XauditModel} from '../xaudit.model';

export class DocumentFolderDataModel extends XauditModel {
  // TODO: spelling
  DocumnetFolderId: string;
  DocumentFolderParentId: string;
  PatientId: string;
  FolderName: string;
  FolderOrder: string;
  enumDocumnetFolderTypeID: string;
}
